/**
 * SPDX-License-Identifier: MIT
 * Copyright (c) 2026 Solvetia. Original work by Solvetia — part of the Solvetia
 * white-label additions to Chatwoot Community Edition (MIT). Not derived from
 * the commercial code under enterprise/.
 */
import ApiClient from './ApiClient';

class AccountRolesAPI extends ApiClient {
  constructor() {
    super('account_roles', { accountScoped: true });
  }
}

export default new AccountRolesAPI();
